import { Autocomplete } from '@mui/material'
import { TextField } from '../../Material/index'
import { Control, Controller, FieldValues, Path, UseFormResetField } from 'react-hook-form'
import { UFParams } from 'types/selects'

interface Props<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  errors: string | undefined
  cidadesByState: (uf: string) => void
  uf: UFParams[]
  resetField: UseFormResetField<T>
  cityFieldName: Path<T>
  disabled?: boolean
  label: string
}

export const UFSelect = <T extends FieldValues>({
  control,
  errors,
  cidadesByState,
  resetField,
  uf,
  cityFieldName,
  disabled = false,
  label,
  name
}: Props<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            value={field.value as string}
            options={uf.map((item) => item.id_uf ?? [])}
            onChange={(event, newValue: string | null) => {
              if (newValue) {
                field.onChange(newValue)
                resetField(cityFieldName)
                cidadesByState(newValue)
              } else {
                field.onChange('')
              }
            }}
            className={'w-full'}
            clearOnBlur={false}
            autoHighlight={true}
            openOnFocus={true}
            noOptionsText={''}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="outlined"
                error={errors ? true : false}
                helperText={errors ?? ''}
                inputProps={{ ...params.inputProps, maxLength: 2 }}
                disabled={disabled}
              />
            )}
          />
        )
      }}
    />
  )
}
